import axiosClient from '../axiosClient';
import { SettingsEndpoints } from '../endpoints/settings';

export interface ISettingResponse {
  metakey: string;
  metavalue: string;
}

export const SettingsService = {
  async getSettingByKeyname(keyname: string): Promise<ISettingResponse> {
    const url = SettingsEndpoints.GET_SETTING_BY_KEYNAME.replace(':keyname', keyname);
    const res = await axiosClient.get<ISettingResponse>(url);
    return res.data;
  },

  async updateSettingValue(keyname: string, keyvalue: string): Promise<boolean> {
    const res = await axiosClient.post<boolean>(SettingsEndpoints.UPDATE_SETTING_VALUE, {
      keyname,
      keyvalue,
    });
    return res.data;
  },
};
